import { FC, useEffect, useRef, useState } from 'react';
import { NavigationProps } from './Navigation.types';
import NavigationItem from '../NavigationItem/NavigationItem';
import { SensibleLogo } from '../assets/png/sensible';
import styles from './navigation.module.scss';

const Navigation: FC<NavigationProps> = ({
  items,
  authButton: AuthButton,
  currentPath,
  logoLinkWrapper,
  langSelector: LangSelector,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!openMenu) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent): void => {
      const target = event.target as Node | null;

      if (
        target &&
        containerRef.current &&
        !containerRef.current.contains(target)
      ) {
        setOpenMenu(false);
      }
    };

    document.addEventListener('pointerdown', handleOutsideClick);

    return () => {
      document.removeEventListener('pointerdown', handleOutsideClick);
    };
  }, [openMenu]);

  const renderNavItems = (): JSX.Element[] => {
    const navItems: JSX.Element[] = [];

    items.forEach((item) =>
      navItems.push(
        <NavigationItem key={item.path} currentPath={item.path === currentPath}>
          {item.element}
        </NavigationItem>,
      ),
    );

    return navItems;
  };

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.logoLink}>
          {logoLinkWrapper(
            <img
              src={SensibleLogo}
              className={styles.logo}
              alt="Sensible Weather logo"
            />,
          )}
        </div>
        {LangSelector && (
          <div className={styles.langSelectorMobile}>{LangSelector}</div>
        )}
        <button
          className={`${styles.mobileMenuIcon} ${openMenu ? styles.open : ''}`}
          onClick={(): void => setOpenMenu((prev) => !prev)}
          type="button"
          aria-label="Toggle Navigation"
          aria-expanded={openMenu}
        >
          <span className={`${styles.dot} ${styles.firstDot}`}></span>
          <span className={`${styles.dot} ${styles.secondDot}`}></span>
          <span className={`${styles.dot} ${styles.thirdDot}`}></span>
        </button>
      </div>

      <div
        className={`${styles.content} ${
          openMenu ? styles.openMenu : styles.closeMenu
        }`}
      >
        <div className={styles.menuContent}>
          <div className={styles.items}>{renderNavItems()}</div>
          {LangSelector && (
            <div className={styles.langSelectorDesktop}>{LangSelector}</div>
          )}
          {AuthButton && <div className={styles.authButton}>{AuthButton}</div>}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
